module.exports = __webpack_public_path__ + "img/ignis-gl.4f496a54.png";